import { Injectable } from '@angular/core';
import { GisTokenService } from './gis-token.service';
import { loadModules } from 'esri-loader';
import { Layer } from '../../builder/components/state/controls/config/data/well-related/gis-map/layer-manager/models/layers.model';
import { mergeMap } from 'rxjs/operators';
import { Observable, from } from 'rxjs';

@Injectable()
export class GisMapHelpersService {

    constructor(
        public _tokenService: GisTokenService
    ) { }

  	addLayers(map: __esri.Map, layers: Layer[]) {
        map.layers.removeAll();

        return from(this._tokenService.getToken()).pipe(mergeMap(val =>
            from(loadModules([
                "esri/layers/FeatureLayer",
                "esri/request",
                "esri/layers/TileLayer",
                "esri/layers/MapImageLayer"
            ])), (token, [FeatureLayer, request, TileLayer, MapImageLayer]) => {
                layers.forEach(x => {
                    let layer = null;
					if (x.customSource) {
						let url = (x.customSource.includes("gis.ohiodnr.gov/ArcGIS/")) ? (x.customSource as string).replace("/ArcGIS/", "/arcgis/") : x.customSource;
                        x.layerInformation = {
							url: url,
                            type: x.customSource.indexOf('MapServer') === -1 ? 'Feature Layer' : 'Map Layer'
                        }
                    }
                    let isRICS: boolean = x.layerInformation.url.indexOf('https://gis.rics-jmt.net') !== -1;
                    switch (x.layerInformation.type) {
                        case 'Feature Layer':
                            layer = new FeatureLayer({
                                url: x.layerInformation.url,
                                title: x.title,
                                token: isRICS ? token : null,
                                id: x.layerInformation.id
                            });
                            break;
                        case 'Map Layer':
                            layer = new MapImageLayer({
                                url: x.layerInformation.url,
                                title: x.title,
                                token: isRICS ? token : null,
                                id: x.identifier
                            });

                            break;
                    }
                    layer.opacity = .5;
                    map.layers.add(layer, 0);
                });
            }));
    }
}
